module.exports = __webpack_public_path__ + "img/link_f_img04.ea64a29f.gif";